// polyfill forEach on NodeList for IE11/Edge
(function () {
  if ( typeof NodeList.prototype.forEach === "function" ) return false;
  NodeList.prototype.forEach = Array.prototype.forEach;
})();

Array.prototype.remove = function(from, to) {
  var rest = this.slice((to || from) + 1 || this.length);
  this.length = from < 0 ? this.length + from : from;
  return this.push.apply(this, rest);
}

window.reloadTooltips = function reloadTooltips() {
  $('.tt').tooltip({container: 'body'});
}
window.reloadDatepickers = function reloadDatepickers() {
  if($.datepicker) $('input.datepicker').datepicker(rwgps.config.datePickerOpts);
}

window.trace = function trace(s) {
  if(window.console && window.console.log) {
    console.log(s); // eslint-disable-line no-console
  }
};

window.stopEvent = function stopEvent(event) {
  event.cancelBubble = true;
  if(event.stopPropagation) {
    event.stopPropagation();
  }
}

window.maybeShowAppInstallPrompt = function maybeShowAppInstallPrompt() {
  if(/Android/i.test(navigator.userAgent) == false) return false;
  if(window.location.pathname.match(/choose_account|settings\/backups|subscriptions\/manage|subscriptions\/new/)) return false;
  if (new URLSearchParams(window.location.search).get('no_app_banner') === 'true') {
    $.cookie("mobile_prompt", '', {expires: 365});
    return false;
  }

  var cookie = $.cookie("mobile_prompt");
  if(cookie == null) {
    $('#android-app-install-modal').modal('show');
    $('#android-app-install-modal a.android-app-install-link').on('click', function() {
      $.cookie("mobile_prompt", '', {expires: 365});
      $("#android-app-install-modal").modal("hide");
    });
    $('#android-app-install-modal a.never-again').on('click', function() {
      $.cookie("mobile_prompt", '', {expires: 365});
    });
    $('#android-app-install-modal a.remind-later').on('click', function() {
      $.cookie("mobile_prompt", '', {expires: 7});
    });
    $('#android-app-install-modal').on('hidden.bs.modal', function() {
      $('#android-app-install-modal .ok').off('click');
    });
  }
}

window.hintify = function hintify($field, lbl) {
  $field.focus(function () { if($field.val() == lbl) $field.val('').removeClass('field_hint'); })
    .blur(function () { if($field.val() == '') $field.val(lbl).addClass('field_hint'); })
    .blur();
}

window.trackEvent = function trackEvent(category, action, label, value) {
  ga('send', 'event', category, action, label, value);
}

// Attach user account level to this google analytics session so that
// we can facet audience segments by account level in reports.
//
// Can be managed at Google Analytics > Admin > Property Settings > Custom Dimensions
$(function() {
  // -1 means unauthenticated
  const currentUserAccountLevel = rwgps.config.currentUser && rwgps.config.currentUser.account_level
  const analyticsAccountLevel = Number.isFinite(currentUserAccountLevel)
    ? currentUserAccountLevel
    : -1
  window.ga && window.ga('set', 'dimension1', analyticsAccountLevel)
})

$(function() {
  function closeOnEnter(e) {
    if(e.keyCode==13) $('#alert_modal').modal('hide');
  }
  $('#alert_modal').on('show.bs.modal', function() {
    $(window).on('keypress', closeOnEnter);
  });
  $('#alert_modal').on('hidden.bs.modal', function() {
    $(window).off('keypress', closeOnEnter);
  });
});
window.customAlert = function customAlert(msg) {
  if (window.rwgps.plannerAlertModal) {
    window.rwgps.plannerAlertModal({msg})
  } else {
    $('#alert_modal .modal-body p').html(msg);
    $('#alert_modal').modal('show');
  }
}
$(function() {
  function confirmOnEnter(e) {
    if(e.keyCode==13) $('#confirm_modal .ok').click();
  }
  $('#confirm_modal').on('show.bs.modal', function() {
    $(window).on('keypress', confirmOnEnter);
  });
  $('#confirm_modal').on('shown.bs.modal', function() {
    $('#confirm_modal .ok').focus();
  });
  $('#confirm_modal').on('hidden.bs.modal', function() {
    $(window).off('keypress', confirmOnEnter);
  });
});
window.customConfirm = function customConfirm(msg, cb, opts) {
  if (window.rwgps.plannerConfirmModal) {
    window.rwgps.plannerConfirmModal({msg, cb})
    return
  }

  if (window._showingCustomConfirm) {
    return
  }
  window._showingCustomConfirm = true

  var oldConfirmText, oldCancelText;
  if(opts) {
    if(opts.confirmText) {
      oldConfirmText = $("#confirm_modal .ok").text();
      $('#confirm_modal .ok').text(opts.confirmText);
    }
    if(opts.cancelText) {
      oldCancelText = $("#confirm_modal .cancel").text();
      $('#confirm_modal .cancel').text(opts.cancelText);
    }
    if (opts.noCancel) {
      $('#confirm_modal .cancel').text('')
    }
  }
  $('#confirm_modal .modal-body p').html(msg);

  $('#confirm_modal').modal('show');
  $('#confirm_modal .ok').on('click', _.once(cb));
  $('#confirm_modal').on('hidden.bs.modal', function() {
    if(oldConfirmText)
      $("#confirm_modal .ok").text(oldConfirmText);
    if(oldCancelText)
      $("#confirm_modal .cancel").text(oldCancelText);

    window._showingCustomConfirm = false
  });
}

var Application = window.Application = {
  initSlideshow: function($parent) {
    $parent.find('img,a.next').click(function() {
      var slide = $(this).closest('.slide');
      if(slide.next('.slide').size() == 0) {
        slide.hide().closest('.slides').find('.slide.first').show();
      } else {
        slide.hide().next('.slide').show();
      }
    });
  },
  preventSpinner: function() {
    $('<div class="prettyLoader"></div>').css('display', 'none').appendTo('body');
  },
  flashLoadCb: function(e) {
    if(!e.success) {
      $('#alternative_content').show();
    }
  },
  initColorbox: function() {
    $('.colorbox').colorbox();
    $('.bigcolorbox').colorbox({width:"970px", height:"80%", maxHeight: '800px', onComplete: function() {
      $('#cboxLoadedContent').addClass('bigbox');
    }});
  },
  initUpsell: function() {
    // newer upsell thing
    const accountLevel = rwgps.config.currentUser ? rwgps.config.currentUser.account_level : 0;
    function showUpsellModal(event) {
      event.preventDefault()
      const el = $(this)
      const feature = el.data('feature')
      const showUpgradeButton = !el.hasClass('featureModal')
      rwgps.upgradeModal({feature, showUpgradeButton})
    }
    if (!rwgps.config.bypassPrivileges) {
      if(accountLevel < 2) {
        $('body').on('click', '.premium_required', showUpsellModal)
      }
      if(accountLevel < 1) {
        $('body').on('click', '.basic_required', showUpsellModal)
      }
    }

    // featureModal shows the modal without the upgrade button (used on the plan info page)
    $('body').on('click', '.featureModal', showUpsellModal)

    // require-privilege is used to handle stuff like special cases for old basic users, etc
    $('body').on('click', '[data-requires-privilege]', function (e) {
      const el = e.target
      const privilege = el.dataset.requiresPrivilege
      const feature = el.dataset.feature
      if (!rwgps.config.privileges[privilege]) {
        e.preventDefault()
        rwgps.upgradeModal({feature, showUpgradeButton: true})
      }
    })

    if(!rwgps.config.currentUser) {
      console.log("no currentUser") //eslint-disable-line
      $('#signup_modal').on('show.bs.modal', function() {
        $(this).css({top: 20}).find('.modal-body').css({
          maxHeight: $(window).height() - 160,
          "overflow-y": "scroll"
        });
      });
      $('#signup_modal').on('shown.bs.modal', function() {
        $(this).find('.fb-signup-btn').focus();
      });
      $('body').on('click', '.login_required', function() {
        var $this = $(this),
            redirect = $this.data('redirect') ? $this.data('redirect') : $this.attr('href');
        $('#signup_modal').modal('show');
        $('#signup_modal input[name=redirect]').val(redirect);
        return false;
      });
    }
  },
  init: function() {
    $(function() {
      Application.initUpsell();
      Application.initColorbox();

      //show garmin write stuff if plugin installed
      if(window.CommunicatorDetector.detectGarminCommunicatorPlugin()) {
        $(".garmin_write").removeClass("hidden")
      }

      // wire up top nav login button to
      $('#login-button').on('click', () => {
        rwgps.loginModalOverlay()
      });

      // sign in link on the sign up modal
      $('#signup_modal a.signin').on('click', function() {
        $('#signup_modal').modal('hide');
        $('#login_form').modal('show');
      });

      // when signin modal pops up focus on email field
      $('#login_form').on('shown.bs.modal', function() {
        $(this).find('input:first').focus();
      });

      // setup global sharing widget
      $('#share_link_modal').on('shown.bs.modal', function() {
        $(this).find('input.share_link').focus().select();
      });
      $('body').on('click', '.share_bar_share_link', function() {
        $('#share_link_modal').modal('show')
          .find('input.share_link').val($(this).data('uri'));
      });

      $('body').on('click', '.share_bar_share_email', function() {
        var assetType = $(this).data('asset_type'),
            assetId = $(this).data('asset_id'),
            assetUrl = $(this).data('uri');
        $('#share_email_modal').modal('show')
          .find('.share_email_asset_type').val(assetType).end()
          .find('.share_email_asset_id').val(assetId).end()
          .find('.share_email_asset_url').val(assetUrl);
      });
      $('#share_email_modal form').ajaxForm({
        success: function(response) {
          $('#share_email_modal').modal('hide');
          $.jGrowl(response.message);
        }
      });

      $('#share_widget_modal').on('shown.bs.modal', function() {
        $(this).find('textarea.share_widget').focus().select();
      });
      $('body').on('click', '.share_bar_share_widget', function() {
        $('#share_widget_modal').modal('show')
          .find('textarea.share_widget').val($(this).data('code'));
      });

      // setup friend requests
      $('body').on('click', '.request_follow', function() {
        var $this = $(this);
        var user = $this.data('user');
        $.post('/follows.json', {"follow": {"item_type": "User", "item_id": user}}, function() {
          $this.fadeOut(400, function() {
            var $conf = $('#followConfirm-' + user);
            if ($conf) {
              $conf.fadeIn();
            }
          });
        });
        return false;
      });


      // setup boosting from the share bar
      $('body').on('click', '.boost_this', function() {
        var path = $(this).attr('href'),
            $li = $(this).closest('li');
        $.post(path+'.json', function() {
          $.jGrowl("Thanks for promoting this! Boosted.");
          $li.slideUp();
        });
        return false;
      });

      $(document).on("click", 'a.delete', function(event){
        event.stopPropagation();
        event.preventDefault();
        var message = $(this).attr('doconfirm');
        var onsuccess = $(this).attr('onsuccess');
        var deleteIt = function() {
          $.post(self.href, {_method: 'delete'}, function() {
            $(self).closest('li').remove();
            if(onsuccess) eval(onsuccess);
          });
        }
        if(message) {
          customConfirm(message, deleteIt);
        } else {
          deleteIt();
        }
      });

      reloadTooltips();

      $(".mini_summary table tr:odd").addClass('alt');
      $('li,tr').hover(function() {
        $(this).addClass('hover');
      }, function() {
        $(this).removeClass('hover');
      });

      $.jGrowl.defaults.position = "bottom-right";

      $('select#units').change(function() {
        if($(this).hasClass('reload')) {
          Application.setPreference('metric_units', $('select#units option:selected').val());
        } else {
          rwgps.LabelMaker.metric = $('select#units option:selected').val() === 'true';
          if(Routes.activeMap.activeRoute) {
            Routes.activeMap.activeRoute.metricsChange();
            Routes.activeMap.populateCuesheet(Routes.activeMap.activeRoute.coursePoints());
            Routes.activeMap.drawRouteDistanceMarkers();
          }
          Application.setPreference('metric_units', $('select#units option:selected').val(), true);
        }
      });

      $('.dont_bubble').live("click", function(event){
        stopEvent(event);
      });

      //conly call this if we have included it (not every page)
      reloadDatepickers();

      if($.prettyLoader) $.prettyLoader({delay: false});

      // Setup close button for AppLinks.
      // This opens rwgps:// links on iPhone
      $('.close_app_link').click(function() {
        $('.app_link').remove(); }
      );

      // End init function
    });
  },
  setupPlaceAutocomplete: function(el) {
    var cache = {},
      lastXhr;
    $(el).autocomplete({
      minLength: 3,
      delay: 200,
      source: function( request, response ) {
        var term = request.term;
        if ( term in cache ) {
          response( cache[ term ] );
          return;
        }
        lastXhr = $.getJSON( "/places/search.json", {q: request.term}, function( data, status, xhr ) {
          var results = _.map(data, function(o) {
            var key = [o.name, o.municipality, o.region].join(', ');
            // cache result so we can get lat/lng
            rwgps.places[key] = o;
            return key;
          });
          results = _.without(results, null);
          // cache top result for this term too
          if(data.length > 0) {
            rwgps.places[request.term] = data[0];
          }

          cache[ term ] = results;
          if ( xhr === lastXhr ) {
            response( results );
          }
        });
      }
    }).keypress(function(e) {
      // if the user presses enter in the search box, cancel the xhr request!
      if(e.keyCode === 13 && lastXhr && lastXhr.abort) lastXhr.abort();
      $(el).autocomplete('close');
    });
  },

  setPreference: function(key, value, silent, route = '/set_preference') {
    Application.preventSpinner();
    $.post(route, {key: key, value: value}, function() {
      if(!silent) window.location.reload();
    });
  },
};

// Multiple file selector by Stickman - thanks Stickman (http://www.the-stickman.com)
window.MultiSelector = function MultiSelector(list_target, object_name){
  // Where to write the list
  this.list_target = list_target
  this.addElement = function( element ){
    // Make sure it's a file input element
    if( element.tagName == 'INPUT' && element.type == 'file' ){
      element.name = object_name + '[photos][]'
        // Add reference to this object
        element.multi_selector = this
        // What to do when a file is selected
        element.onchange = function(){
          // New file input
          var new_element = document.createElement( 'input' )
            // give the id to the new input from the old one
            var id = $(this).attr('id');
            $(this).attr('id','');
            $(new_element).attr('id', id);

            new_element.type = 'file'
            // Add new element
            this.parentNode.insertBefore( new_element, this )
            // Apply 'update' to element
            this.multi_selector.addElement( new_element )
            // Update list
            this.multi_selector.addListRow( this )
            // Hide this: we can't use display:none because Safari doesn't like it
            this.style.position = 'absolute'
            this.style.left = '-1000px'
        }
        // Most recent element
        this.current_element = element
      } else {
        // This can only be applied to file input elements!
        alert( 'Error: not a file input element' )
      }
    }

    /**
    * Add a new row to the list of files
    */
    this.addListRow = function( element ){
      // Row div
      var new_row = document.createElement( 'div' )
      // Delete button
      var new_row_button = document.createElement( 'input' )
      new_row_button.type = 'button'
      new_row_button.value = 'Delete'
      // References
      new_row.element = element
      // Delete function
      new_row_button.onclick= function(){
        // Remove element from form
        this.parentNode.element.parentNode.removeChild( this.parentNode.element )
        // Remove this row from the list
        this.parentNode.parentNode.removeChild( this.parentNode )
        // Re-enable input element (if it's disabled)
        this.parentNode.element.multi_selector.current_element.disabled = false

        // Appease Safari
        //    without it Safari wants to reload the browser window
        //    which nixes your already queued uploads
        return false
      }
    // Set row value
    new_row.innerHTML = element.value
    // Add button
    new_row.appendChild( new_row_button )
    // Add it to the list
    this.list_target.appendChild( new_row )
  }
}

window.centeredpopup = function centeredpopup(url, title, w, h) {
    var wLeft = window.screenLeft ? window.screenLeft : window.screenX;
    var wTop = window.screenTop ? window.screenTop : window.screenY;

    var left = wLeft + (window.innerWidth / 2) - (w / 2);
    var top = wTop + (window.innerHeight / 2) - (h / 2);
    return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
};

// https://gist.github.com/paulirish/1579671
(function() {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
                                   || window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function(callback) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() { callback(currTime + timeToCall); },
              timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };

    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
}());

// guarantee transition end fires
// http://blog.alexmaccaw.com/css-transitions
var transitionEndEvent = window.transitionEndEvent = (function (){
  var t;
  var el = document.createElement('fakeelement');
  var transitions = { 'transition':'transitionend', 'MSTransition':'msTransitionEnd', 'MozTransition':'transitionend', 'WebkitTransition':'webkitTransitionEnd' };
  for(t in transitions){
    if( el.style[t] !== undefined ){
      return transitions[t];
    }
  }
  return "fakeTransitionEndEvent";
})();
$.fn.emulateTransitionEnd = function(duration) {
  var called = false, $el = this;
  $(this).one(transitionEndEvent, function() { called = true; });
  var callback = function() { if (!called) $($el).trigger(transitionEndEvent); };
  setTimeout(callback, duration);
  return this;
};


// overwrite innerWidth, innerHeight, outerWidth & outerHeight because our old version of jQuery UI is breaking these functions.
// if you remove this code, $el.outerHeight() will return an element, when it should return a number. You can remove this once
// jQuery UI is updated.
jQuery.each( [ "Width", "Height" ], function( i, name ) {
  var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
    type = name.toLowerCase(),
    orig = {
      innerWidth: jQuery.fn.innerWidth,
      innerHeight: jQuery.fn.innerHeight,
      outerWidth: jQuery.fn.outerWidth,
      outerHeight: jQuery.fn.outerHeight
    };

  function reduce( elem, size, border, margin ) {
    jQuery.each( side, function() {
      size -= parseFloat( jQuery.css( elem, "padding" + this, true) ) || 0;
      if ( border ) {
        size -= parseFloat( jQuery.css( elem, "border" + this + "Width", true) ) || 0;
      }
      if ( margin ) {
        size -= parseFloat( jQuery.css( elem, "margin" + this, true) ) || 0;
      }
    });
    return size;
  }

  jQuery.fn[ "inner" + name ] = function( size ) {
    if ( size === undefined ) {
      return orig[ "inner" + name ].call( this );
    }

    return this.each(function() {
      jQuery( this ).css( type, reduce( this, size ) + "px" );
    });
  };

  jQuery.fn[ "outer" + name] = function( size, margin ) {
    // default to false
    if (size === undefined) {
      size = false;
    }

    if ( typeof size !== "number" ) {
      return orig[ "outer" + name ].call( this, size );
    }

    return this.each(function() {
      jQuery( this).css( type, reduce( this, size, true, margin ) + "px" );
    });
  };
});

$('.globalMenuOpen').on('click', () => {
  $('body').addClass('noscroll')
  $('.globalNav').addClass('open')
})
$('.globalMenuClose').on('click', () => {
  $('body').removeClass('noscroll')
  $('.globalNav').removeClass('open')
})

rwgps.ns('signup').init = function () {
  rwgps.ns('users.signup.params', function () {
    var ns = this;
    $('#user_email,#user_email_confirmation','#new_user').val(ns.email);
    if (ns.duplicate_email) {
      $('#duplicate_email_modal').modal('show');

      $('.goto-login', '#duplicate_email_modal').on('click', function (e){
        e.preventDefault();

        $('#duplicate_email_modal').modal('hide');
        rwgps.loginModalOverlay(); // TODO: prepopulate email field
      });

      $('.reset-password', '#duplicate_email_modal').on('click', function (e) {
        e.preventDefault();
        $('#email', '#duplicate_email_modal').val(ns.email);

        $('.forgot_password form', '#duplicate_email_modal').ajaxSubmit({
          dataType: 'json',
          success: function() {
            $('#duplicate_email_modal').modal('hide');
            window.customAlert('An email was sent to the email address you provided with instructions to reset your password on Ride with GPS.')
          }
        });
      });
    }
  })
}



// WEBPACK FOOTER //
// ./public/javascripts/application.js